import { Routes, Route, Navigate } from 'react-router-dom'

import { useAuthStore } from '@/stores/authStore'
import { AppShell } from '@/components/layout/AppShell'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { Toaster } from '@/components/ui/toaster'
import { LoginPage } from '@/pages/LoginPage'
import { DashboardPage } from '@/pages/DashboardPage'
import { ArticlesPage } from '@/pages/ArticlesPage'
import { ArticleDetailPage } from '@/pages/ArticleDetailPage'
import { ArticleEditPage } from '@/pages/ArticleEditPage'
import { SitesPage } from '@/pages/SitesPage'
import { SchedulesPage } from '@/pages/SchedulesPage'
import { SettingsPage } from '@/pages/SettingsPage'
import { AgentSettingsPage } from '@/pages/AgentSettingsPage'
import { BatchUploadPage } from '@/pages/BatchUploadPage'
import { ContentCalendarPage } from '@/pages/ContentCalendarPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <ErrorBoundary>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AppShell />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="articles" element={<ArticlesPage />} />
          <Route path="articles/:id" element={<ArticleDetailPage />} />
          <Route path="articles/:id/edit" element={<ArticleEditPage />} />
          <Route path="articles/batch" element={<BatchUploadPage />} />
          <Route path="calendar" element={<ContentCalendarPage />} />
          <Route path="schedules" element={<SchedulesPage />} />
          <Route path="sites" element={<SitesPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="settings/agents" element={<AgentSettingsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Toaster />
    </ErrorBoundary>
  )
}

export default App
